import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCheckmark2Medium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"checkmark-2-medium"} maskId="square-filled-radius-0-stroke-1-IconCheckmark2Medium"><path d="M20.0586 6.93848L9.23633 19.0869L3.93945 13.8848L4.99023 12.8145L9.16309 16.9121L18.9385 5.94141L20.0586 6.93848Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCheckmark2Medium;
